import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import { HotelInformationExtendsComponent } from '../hotel-information-extends/hotel-information-extends.component';

@Component({
  selector: 'app-hotel-list',
  templateUrl: './hotel-list.component.html',
  styleUrls: ['./hotel-list.component.css']
})
export class HotelListComponent implements OnInit {
  @ViewChild(HotelInformationExtendsComponent) HotelInformationExtendsComponent: any;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    private routeActivated: ActivatedRoute,
    private router: Router,
    private hotelService: HotelService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.hotelService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
    // setTimeout(() => {
    // }, 500);
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    // let currentUrl = this.router.url;
    // console.log(currentUrl);
    // this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    //   this.router.navigate([currentUrl]);
    // });
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/turismo/hoteles/editar',
      id
    ]);
  }

  delete(item: any, _index:any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.tradename,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.hotelService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success('El registro '+item.tradename+' se ha eliminado con éxito');
            this.list();
          }
        });
      }
    });
  }

  showHotel(item_: any) {
    let data: any = {};
    data.hotel_data = item_;
    this.HotelInformationExtendsComponent.init(data);
  }
}

